import React, { useEffect, useState } from 'react'
import {
  Table,
  Form,
  Input,
  Select,
  Button,
  Space,
  Card,
  Row,
  Col,
  Switch,
  message,
  Modal,
  Popconfirm,
} from 'antd'
import { SearchOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons'
import styles from './ResourceManager.module.css'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'

import { Pagination } from 'antd'

import {
  changeZiyuanStatusRequest,
  getInfoListRequest,
} from './api.js'
import {
  closeUserInfo,
  closeAdminPage,
  openLogin,
} from '../../../store/modalsSlice.js'
import settingIcon from './setting.svg'
import { useDispatch } from 'react-redux'
import InfoItem from './InfoItem.jsx'
import { clearAllCookies } from '../../../util/handleObject.js'

import CommonModal from './add/Common.js'
import EditCommonModal from './edit/Common.js'



const { Option } = Select

const ResourceManager = () => {
  const dispatch = useDispatch()
  // 筛选表单状态
  const [filterForm, setFilterForm] = useState({
    nameKey: '',
    status: '',
  })
  const [dataList, setDataList] = useState([])
  // 分页状态

  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isShowEditCommon, setIsShowEditCommon] = useState(false)
  const [editInfo, setEditInfo] = useState({
  })
  const [totalNumber, setTotalNumber] = useState(0)
  const [limit, setLimit] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)

  useEffect(() => {
    getInfoList(
      filterForm.nameKey,
      filterForm.status,
      (currentPage - 1) * limit,
      limit,
    )
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次


  function updateData() {
    getInfoList(
      filterForm.nameKey,
      filterForm.status,
      (currentPage - 1) * limit,
      limit,
    )
  }

  // 处理状态切换
  const handleStatusChange = (info, checked) => {
    changeZiyuanStatusRequest(info.code,checked?1:0, (res) => {
      if (res.ret == 1) {
        message.success('状态更新成功')
        updateData()
      } else {
        message.error(res.msg)
      }
    })
  }

  // 处理筛选表单变化
  const handleFilterChange = (name, value) => {
    setFilterForm({
      ...filterForm,
      [name]: value,
    })
  }

  // 处理重置筛选
  const handleResetFilter = () => {
    setFilterForm({
      nameKey: '',
      status: '',
    })
    setCurrentPage(1)
    // 重置后重新获取所有数据
  }

  const onShowSizeChange = (page, pageSize) => {
    //pageSize 变化的回调
    console.log(page, pageSize)
    setCurrentPage(1)
    setLimit(pageSize)
  }

  const onChangePage = (current, pageSize) => {
    //页码或 pageSize 改变的回调，参数是改变后的页码及每页条数
    setCurrentPage(current)
    getInfoList(
      filterForm.nameKey,
      filterForm.status,
      (current - 1) * pageSize,
      pageSize,
    )
  }


  const getInfoList = (nameKey,status,offset,limit) => {
    getInfoListRequest(
      nameKey,
      status,
      offset,
      limit,
      (res) => {
        if (res.ret == 1) {
          setDataList(res.data.list)
          setTotalNumber(res.data.total_num)
        } else {
          message.error(res.msg)
        }
      },
    )
  }
  function closeCommonModal() {
    setIsModalVisible(false)
    setIsShowEditCommon(false)
  }

  return (
    <div className={styles.background}>
      <div className={styles.rightMenus}>
        <div className={styles['div-top']}>
          <h3 style={{ marginLeft: 30 }}>学校信息管理</h3>

          <Popconfirm
            placement="bottom"
            title={''}
            description={'是否退出登录'}
            okText="是"
            cancelText="否"
            onConfirm={(e) => {
              sessionStorage.clear()
              clearAllCookies()
              dispatch(closeAdminPage())
              dispatch(openLogin())
            }}
          >
            <div className={styles.iconContainer}>
              <img
                src={settingIcon}
                style={{ width: '20px', height: '20px' }}
              />
            </div>
          </Popconfirm>

          <Button
            className={styles['bt-refresh']}
            type="primary"
            onClick={(e) => {
              // getUserList(
              //   (currentPage - 1) * limit,
              //   limit,
              // )
            }}
          >
            刷新
          </Button>
        </div>

        <Card title="" className={styles['card-top']}>
          <div className={styles['div-shaixuan']}>
            <div>数据筛选</div>

            <Space className={styles['bt-shaixuan2']}>
              <Button onClick={handleResetFilter}>重置</Button>
              <Button type="primary" onClick={() => {
                getInfoList(
                  filterForm.nameKey,
                  filterForm.status,
                  (currentPage - 1) * limit,
                  limit,
                )
              }}>
                查询
              </Button>
            </Space>
          </div>
          <Row gutter={24} align="middle">
            <Col>
              <Row align="middle">
                <Col flex="50px">关键字</Col>
                <Col
                  // flex="auto"
                  style={{ width: 'calc(100% - 50px)' }}
                >
                  <Input
                    placeholder="关键字"
                    value={filterForm.nameKey}
                    onChange={(e) => handleFilterChange('nameKey', e.target.value)}
                  />
                </Col>
              </Row>
            </Col>
            <Col>
              <Row align="middle">
                <Col flex="40px">状态</Col>
                <Col
                  // flex="auto"
                  style={{ width: 'calc(100% - 50px)' }}
                  justify="start"
                >
                  <Select
                    style={{ minWidth: '88px' }}
                    placeholder="状态"
                    value={filterForm.status}
                    onChange={(value) => handleFilterChange('status', value)}
                  >
                    <Option value="">全部</Option>
                    <Option value="1">正常</Option>
                    <Option value="3">禁用</Option>
                  </Select>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>

        <Card title="" className={styles['card-bottom']}>
          <div className={styles['container-list']}>
            <div className={styles['div-shaixuan']}>
              <div>数据列表</div>

              <Button
                style={{ marginLeft: 'auto' }}
                type="primary"
                onClick={() => {
                  setIsModalVisible(true)
                }}
              >
                添加
              </Button>
            </div>

            <div className={styles.tableContainer}>
              <table className={styles.infoTable}>
                <tr className={styles.tr1}>
                  <td className={styles.td1}>文件名称</td>
                  <td className={styles.td2}>消耗积分</td>
                  <td className={styles.td2}>累计下载次数</td>
                  <td className={styles.td2}>文件大小</td>
                  <td className={styles.td2}>状态</td>
                  <td className={styles.td2}>创建时间</td>
                  <td className={styles.td2}>操作</td>
                </tr>
                {dataList.map((item, index) => (
                  <InfoItem
                    item={item}
                    key={index + 1}
                    index={index + 1}
                    editMethod={(info) => {
                      console.log(info)
                      setEditInfo(info)
                      setIsShowEditCommon(true)
                    }}
                    changeStatus={(info, checked) => {
                      handleStatusChange(info, checked)
                    }}
                  />
                ))}
              </table>

              {/* 分页控件 - 右下角 */}
            </div>
            <Pagination
              hideOnSinglePage={false} //只有一页隐藏分页器
              align="end"
              style={{ marginTop: 20 }}
              showSizeChanger //是否展示 pageSize 切换器，当 total 大于 50 时默认为 true
              onShowSizeChange={onShowSizeChange} //pageSize 变化的回调
              defaultCurrent={1}
              current={currentPage}
              total={totalNumber}
              locale={{
                items_per_page: '条/页', // 将 "/page" 改为 "/页"
              }}
              pageSizeOptions={['10', '20', '30']} // 自定义选项值
              pageSize={limit}
              onChange={onChangePage}
              showLessItems={false} // 关闭"简化显示"模式
            />
          </div>
        </Card>
      </div>
      <CommonModal
          updateData={updateData}
          openStatus = {isModalVisible}
          closeCommonModal={closeCommonModal}
      />
      <EditCommonModal
        updateData={updateData}
        openStatus = {isShowEditCommon}
        closeCommonModal={closeCommonModal}
        editInfo={editInfo}
      />
    </div>
  )
}

export default ResourceManager
